module.exports = "/assets/8348d237a68630f3aca3e648c49753a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KU.png
// module id = 2682
// module chunks = 0